import React from "react";
import { Navigate } from "react-router-dom";
import { get_cookie } from "../../utility/cookies";

const PrivateRoute = ({ children }) => {
  if (!get_cookie("@serial")) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
